import ACA from '@adactive/adsum-utils/services/ClientAPI';
import { Path } from '@adactive/adsum-web-map';

export const getPoi = (object) => {
    if (object && object.placeId) {
        return ACA.getPoisFromPlace(object.placeId);
    }
    return null;
};

export const getPlace = (object) => {
    const poi = getPoi(object);
    if (poi && poi.length && poi.length > 0) {
        poi[0].placeId = object.placeId;
        return ACA.getPlace(object.placeId);
    }
    return null;
};

export const checkComputedPath = async (object) => {
    try {
        const place = getPlace(object);
        const locationRepo = this.awm ? this.awm.wayfindingManager.locationRepository : null;
        const path = new Path(locationRepo.userLocation, locationRepo.locations.get(place.id));
        await this.awm.wayfindingManager.computePath(path);
        return true;
    } catch (err) {
        return false;
    }
};



// WEBPACK FOOTER //
// ./src/utils/functions.js